// Albanian translations (Shqip)
export const sq = {
  // Navigation
  nav: {
    home: "Fillimi",
    rooms: "Dhomat",
    amenities: "Lehtësirat",
    gallery: "Galeria",
    virtualTour: "Tur Virtual",
    location: "Vendndodhja",
    contact: "Kontakti",
    bookNow: "Rezervo Tani"
  },
  
  // Hero
  hero: {
    tagline: "Hotel familjar 3-yjor, 2 minuta nga Plazhi i Madh, Ulqin",
    description: "Hotel i thjeshtë familjar 3-yjor në Kepi i Gjeranave, rreth 2 minuta në këmbë nga rëra në fillim të Plazhit të Madh, plazhit 12 km të Ulqinit. Mëngjesi, darka, pishina, Wi-Fi dhe garazhi përfshihen. Dhomat janë të pastra dhe funksionale, jo luksoze — shumica me ballkon, shumë shohin nga deti.",
    exploreRooms: "Eksploro Dhomat",
    viewGallery: "Shiko Galerinë",
    veryGood: "Shumë Mirë",
    reviews: "komente",
    starHotel: "Hotel 3-Yje",
    bookDirect: "Rezervo Direkt dhe Kurse",
    bestPrice: "Më lirë se në Booking.com për të njëjtën dhomë",
    freeCancellation: "Anulim falas në tarifat fleksibile",
    noBookingFees: "Pa tarifa rezervimi",
    checkAvailability: "Kontrollo Disponueshmërinë →"
  },
  
  // Booking
  booking: {
    checkAvailability: "Kontrollo Disponueshmërinë dhe Rezervo",
    checkIn: "Check-in",
    checkOut: "Check-out",
    adults: "Të Rritur",
    children: "Fëmijë",
    adult: "I Rritur",
    child: "Fëmijë",
    searchAvailability: "Kërko Disponueshmërinë",
    secureBooking: "Rezervim i sigurt • Garanci e çmimit më të mirë • Anulim falas për shumicën e dhomave",
    freeCancellation: "Anulim falas për shumicën e rezervimeve"
  },
  
  // Rooms
  rooms: {
    title: "Dhoma të thjeshta e të pastra pranë plazhit",
    subtitle: "Akomodimi",
    description: "13 lloje dhomash, nga një dhomë teke kompakte deri te apartamenti me dy dhoma gjumi. Çdo dhomë ka kondicioner, banjo private dhe Wi-Fi falas; shumica kanë ballkon. Mobiliet janë funksionale, jo dizajni.",
    viewDetails: "Shiko Detajet",
    bookNow: "Rezervo Tani",
    perNight: "/natë",
    guests: "Vizitorë",
    backToRooms: "Kthehu te Të Gjitha Dhomat",
    roomAmenities: "Lehtësirat e Dhomës",
    standardFeatures: "Karakteristikat Standarde"
  },
  
  // Room Names (Albanian)
  roomNames: {
    room1: "Dhomë dyshe me pamje nga deti dhe ballkon",
    room2: "Dhomë dyshe pranë pishinës",
    room3: "Dhomë dyshe ekonomike me ballkon (pa pamje)",
    room4: "Dhomë binjake me pamje nga deti dhe tarracë të përbashkët",
    room5: "Dhomë treshe ekzekutive me pamje nga deti dhe ballkon",
    room6: "Dhomë dyshe me shtrat shtesë - pamje nga deti dhe ballkon",
    room7: "Apartament familjar me dy dhoma gjumi",
    room8: "Dhomë familjare me tarracë të përbashkët",
    room9: "Dhomë familjare me tarracë",
    room10: "Dhomë e vogël njëshe",
    room11: "Dhomë treshe me ballkon",
    room12: "Dhomë familjare me pamje nga mali",
    room13: "Apartament me një dhomë gjumi"
  },
  
  // Amenities
  amenities: {
    title: "Lehtësirat e Hotelit",
    subtitle: "Çfarë Ofrojmë",
    beachfront: "Vendndodhje në Plazh",
    beachfrontDesc: "Qasje e drejtpërdrejtë në plazhin e gjatë",
    childrenPool: "Pishina për Fëmijë",
    childrenPoolDesc: "Pishinë e sigurt për familje",
    restaurant: "Restorant dhe Kafene",
    restaurantDesc: "Kuzhinë ballkanike · pa alkool",
    wifi: "WiFi Falas",
    wifiDesc: "Internet me shpejtësi të lartë",
    parking: "Parking Falas",
    parkingDesc: "Parking i sigurt",
    shuttle: "Transfer Aeroporti",
    shuttleDesc: "€80 nga aeroporti i Podgoricës dhe Tivatit (me kërkesë)",
    frontDesk: "Recepsion 24-Orësh",
    frontDeskDesc: "Shërbim 24/7",
    elevator: "Qasje me Ashensor",
    elevatorDesc: "Të gjitha katet"
  },
  
  // Gallery
  gallery: {
    intro: "Zbuloni bukurinë e Hotel La Rosa Negra dhe sharmin e Ulqinit.",
    title: "Galeria e Fotografive",
    subtitle: "Eksploro Hotelin Tonë",
    all: "Të gjitha",
    rooms: "Dhomat",
    pool: "Pishina",
    beach: "Plazhi",
    restaurant: "Restoranti",
    exterior: "Eksterieri"
  },
  
  // Virtual Tour
  virtualTour: {
    title: "Tur Virtual 360°",
    subtitle: "Përjeto Hotelin Tonë",
    description: "Bëni një shëtitje virtuale nëpër hotelin tonë të bukur"
  },
  
  // Location
  location: {
    title: "Vendndodhja Jonë",
    subtitle: "Na Gjeni",
    address: "Adresa",
    nearbyAttractions: "Atraksione Afër"
  },
  
  // Contact
  contact: {
    title: "Na Kontaktoni",
    subtitle: "Lidhuni Me Ne",
    name: "Emri",
    email: "Email",
    message: "Mesazhi",
    send: "Dërgo Mesazhin",
    phone: "Telefoni",
    whatsapp: "WhatsApp"
  },
  
  // FAQ
  faq: {
    intro: "Përgjigje për pyetjet më të shpeshta rreth Hotel La Rosa Negra.",
    title: "Pyetjet e Bëra Shpesh",
    subtitle: "FAQ"
  },
  
  // Footer
  footer: {
    quickLinks: "Lidhje të Shpejta",
    contactInfo: "Informacioni i Kontaktit",
    followUs: "Na Ndiqni",
    rights: "Të gjitha të drejtat e rezervuara",
    starHotel: "Hotel me yje",
    description: "Përjetoni kombinimin perfekt të hijeshisë mesdhetare dhe komoditetit modern direkt në Plazhin e Madh, Ulqin, Mali i Zi.",
    rooms: "Dhoma dhe Apartamente",
    amenities: "Lehtësirat",
    gallery: "Galeria",
    location: "Vendndodhja",
    reviews: "Komentet",
    legal: "Ligjore",
    privacy: "Politika e Privatësisë",
    terms: "Termat dhe Kushtet",
    cookies: "Politika e Kukive",
    cancellation: "Politika e Anulimit"
  },

  // Smart language-hint toast
  langHint: {
    message: "Kjo faqe është gjithashtu e disponueshme në shqip",
    switch: "Ndrysho",
    dismiss: "Mbyll"
  },
  
  // Why Book Direct
  whyBookDirect: {
    eyebrow: "Rezervim direkt",
    heading: "Pse të rezervoni direkt?",
    lead: "Këtu kushton më pak se në Booking.com dhe merreni vesh direkt me ne — ja çfarë merrni saktësisht",
    b1t: "Çmim më i ulët se Booking.com",
    b1d: "Çmimi ynë direkt është 10% nën çmimin tonë në Booking.com për të njëjtën dhomë dhe data. E gjetët më lirë atje? Na dërgoni linkun dhe e barazojmë.",
    b2t: "10% zbritje",
    b2d: "10% është tashmë në çmimin që shihni këtu — pa kod, pa tarifa shtesë.",
    b3t: "Kushte të qarta anulimi",
    b3d: "Tarifat fleksibile anulohen falas deri në datën e treguar gjatë rezervimit; tarifat e pakthyeshme shënohen qartë para pagesës.",
    b4t: "Përgjigjet një njeri",
    b4d: "WhatsApp, telefon ose e-mail — recepsioni zakonisht përgjigjet brenda disa orësh, 08:00–23:00.",
    cta: "Rezervoni direkt dhe kurseni"
  },

  // Amenities section headings/CTA
  amenitiesSection: {
    eyebrow: "Lehtësirat",
    heading: "Çfarë ka hoteli",
    lead: "Lehtësirat që ekzistojnë vërtet — as më shumë, as më pak.",
    ctaTitle: "Pyetje para rezervimit?",
    ctaLead: "Na pyesni çdo gjë për dhomat, plazhin ose ardhjen — përgjigjemi sinqerisht.",
    ctaButton: "Kontaktoni koncierzhin"
  },

  // Contact section
  contactForm: {
    title: "Shkruani ekipit të duhur",
    subtitle: "Zgjidhni departamentin dhe do t'ju përgjigjemi brenda një dite pune.",
    dep_sales: "Shitje", hint_sales: "Rezervime grupore, evente, tarifa korporative, agjenci",
    dep_jobs: "Aplikim për punë", hint_jobs: "Na dërgoni CV-në — recepsion, pastrim, F&B, mirëmbajtje",
    dep_pr: "Marrëdhënie me publikun", hint_pr: "Media, shtyp, partneritete dhe bashkëpunime",
    name: "Emri juaj", email: "Adresa e emailit", phone: "Telefon (opsional)", subject: "Subjekti", position: "Pozicioni për të cilin aplikoni",
    message: "Mesazhi juaj", messageJobs: "Na tregoni për veten, përvojën dhe disponueshmërinë",
    attachCv: "Bashkëngjit CV (PDF ose Word, max 5 MB)", send: "Dërgo mesazhin",
    successTitle: "Mesazhi u dërgua!", successBody: "Faleminderit — mesazhi juaj arriti te ekipi:", sendAnother: "Dërgo një mesazh tjetër",
    error: "Dërgimi dështoi. Provoni përsëri.", privacy: "Të dhënat tuaja përdoren vetëm për t'ju përgjigjur."
  },
  contactSection: {
    eyebrow: "Na kontaktoni",
    heading: "Lidhuni me ne",
    lead: "Keni pyetje? Jemi këtu për të ndihmuar. Na kontaktoni në çdo kohë.",
    addressLabel: "Adresa",
    phoneLabel: "Telefoni",
    emailLabel: "Email",
    receptionLabel: "Orari i recepsionit",
    reception247: "24/7 - Gjithmonë jemi këtu për ju",
    whatsappBtn: "Bisedoni në WhatsApp",
    emailBtn: "Dërgo email",
    bookDirectTitle: "Rezervoni direkt dhe kurseni",
    bookDirectDesc: "Merrni 10% zbritje kur rezervoni përmes faqes sonë",
    checkAvailability: "Kontrolloni disponueshmërinë",
    whatsappPrefill: "Përshëndetje, dëshiroj të informohem për Hotel La Rosa Negra"
  },

  // Reviews section
  reviews: {
    eyebrow: "Vlerësimet e mysafirëve",
    heading: "Çfarë thonë mysafirët — pa ndryshime",
    lead: "Vlerësimet janë kopjuar nga Booking.com siç janë shkruar, përfshirë kritikat. Gjykoni vetë.",
    veryGood: "Shumë mirë",
    reviewsCount: "komente",
    starHotel: "Hotel 3-Yje",
    readMoreOn: "Lexoni më shumë komente në",
    translatedFrom: "Përkthyer nga {lang}",
    showOriginal: "Shfaq origjinalin",
    showTranslation: "Shfaq përkthimin"
  },

  // Handoff
  handoff: {
    prompt: "Preferoni të bisedoni me ekipin tonë?",
    button: "Vazhdo në WhatsApp",
    prefix: "Përshëndetje Hotel La Rosa Negra! Kam biseduar me asistentin tuaj virtual dhe do të doja të vazhdoja me një person."
  },

  // Common
  common: {
    learnMore: "Mëso Më Shumë",
    seeAll: "Shiko të Gjitha",
    close: "Mbyll",
    loading: "Duke ngarkuar..."
  }
};
